export default __webpack_public_path__ + "static/media/logoImg.cf7e1dd5.png";